import React from "react";
import "bootstrap/dist/css/bootstrap.min.css";
import $ from "jquery";
import "bootstrap/dist/js/bootstrap.bundle.min";
import "../assets/css/icons.css";
import "../assets/css/style.css";
import ralogo from "../assets/images/RemoteAssist.png";
import user_img from "../assets/images/user/user.svg";
import { SERVER_IP, jwt, ud, auth_response_flow, Communication_obj, Security, LICENSE } from "../Server";
import { GetLiveUsers } from "../SocketData";
import axios from "axios";
import { NavLink, withRouter } from "react-router-dom";
import {
  AssignedWorkflowIcon,
  CallIcon,
  CallPLusIcon,
  CallPLusIconActive,
  DashboardIcon,
  FaqIcon,
  FilesIcon,
  LibraryIcon,
  TeamDashboardIcon,
  WorkflowIcon,
} from "../assets/Icons";
import { connect } from "react-redux";
import { ACTIVITY_PERMISSION, DASHBOARD_PERMISSION, HOME_PERMISSION, QUESTION_BANK_PERMISSION, TEAM_DASHBOARD_PERMISSION, WORKFLOW_BUILDER_PERMISSION } from "../constant/constant";

var socket;
var simulanisimg = ud && ud.cooperate_logo ? ud.cooperate_logo : user_img;

class Sidebar extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      showChats: Communication_obj,
      server: `${SERVER_IP}`,
      user_list: [],
      calling: false,
      calling_mode: "",
      socket_id: "",
      room_id: "0",
      userArrObj: [],
      select_user_popup: false,
      webgl_token: "",
      openSubMenu: "",
    };
  }

  componentWillReceiveProps(props) {
    if (socket === undefined) {
      if (props.socket) {
        this.connectToSocket(props.socket);
      }
    }
  }

  componentDidMount() {
    var webgl_token = sessionStorage.getItem("webgl_token");
    this.setState({ webgl_token: webgl_token });

    if (ud.usertype !== 0 && Security) {
      setTimeout(() => this.userSessionUpdate(), 2000);
      setInterval(() => this.userSessionUpdate(), 15000);
    }

    $(".xp-vertical-menu li").on("click", function () {
      $(this).siblings().removeClass("active");
      $(this).addClass("active");
    });

    if (this.state.showChats) {
      this.connectToSocket(this.props.socket);
    }

    this.dataByLicense();
  }

  dataByLicense = () => {
    if (LICENSE.application_Dashboard) {
      this.setState(this.state);
    } else {
      setTimeout(() => {
        this.dataByLicense();
      }, 1000);
    }
  };

  formatDate = (date) => {
    let d = new Date(date);
    let month = (d.getMonth() + 1).toString().padStart(2, "0");
    let day = d.getDate().toString().padStart(2, "0");
    let year = d.getFullYear();
    return [year, month, day].join("-");
  };

  userSessionUpdate = () => {
    var reqData = {
      session_id: ud.session_id,
    };
    let headers = {
      user_id: ud.id.toString(),
      session_id: ud.session_id.toString(),
      user_type: ud.usertype.toString(),
      main_id: ud.main_id.toString(),
      jwt_token: jwt,
      c_id: ud.c_id.toString(),
    };

    axios
      .post(`${SERVER_IP}/usersUserSessionUpdate`, reqData, {
        withCredentials: true,
        headers: headers,
      })
      .then((response) => {
        if (response.data.error) {
          auth_response_flow(response.data, (return_response) => {
            if (!return_response.error && return_response.retry) {
              this.userSessionUpdate();
            }
          });
        }
      })
      .catch(() => { });
  };

  connectToSocket = (socketinfo) => {
    socket = socketinfo;
    if (socket) {
      this.LiveUserList();
    }
  };

  LiveUserList = () => {
    setTimeout(() => {
      GetLiveUsers((ActiveUsers) => {
        this.setState({ user_list: ActiveUsers });
      });
    }, 2000);

    socket.on("live_users_list", (data) => {
      if (data.data === "NEW") {
        if (!this.state.user_list.find((raw) => raw.user_id == data.liveusers[0].user_id)) {
          this.state.user_list.push(data.liveusers[0]);
          this.setState(this.state);
        }
      } else if (data.data === "ALL") {
        this.setState({ user_list: data.liveusers });
      } else if (data.data === "DELETE") {
        const delIndex = this.state.user_list.findIndex((x) => x.user_id === data.liveusers[0].user_id);
        if (delIndex > -1) {
          this.state.user_list.splice(delIndex, 1);
          this.setState(this.state);
        }
      } else if (data.data === "UPDATE") {
        const updIndex = this.state.user_list.findIndex((x) => x.user_id === data.liveusers[0].user_id);
        if (updIndex > -1) {
          this.state.user_list[updIndex] = data.liveusers[0];
          this.setState(this.state);
        }
      }
    });
  };

  emit_I_AM_ONLINE = () => {
    const json_data = {
      user_id: ud.id,
      session_id: ud.session_id,
      receive_data: true,
      datetime: this.formatDate(new Date()) + " " + new Date().toLocaleTimeString(),
    };
    socket.emit("i_am_online", json_data);
  };

  vmenuclose() {
    document.getElementsByClassName("xp-leftbar")[0].style.display = "none";
  }

  handleSubMenuToggle = (menuKey) => {
    this.setState((prevState) => ({
      openSubMenu: prevState.openSubMenu === menuKey ? "" : menuKey,
    }));
  };

  render() {
    const { pathname } = this.props.location;
    const { userDetails } = this.props;
    let permissionList = userDetails?.user?.permissions || [];

    return (
      <div className="xp-leftbar">
        <div className="xp-sidebar">
          <div className="xp-logobar pt-3">
            <NavLink to="/dashboard" className="xp-logo pl-1">
              <span className="logoimg">
                <img src={ralogo} className="img-fluid" alt="logo" />
              </span>
              <span className="logoname">Remote Assist</span>
            </NavLink>
            <span className="sideclose d-block d-md-none" onClick={this.vmenuclose}>
              <i className="fa fa-times"></i>
            </span>
          </div>

          <div className="xp-navigationbar">
            <ul className="xp-vertical-menu">
              {permissionList.includes(HOME_PERMISSION) && <li className={pathname === "/" ? "active" : ""}>
                <NavLink to="/"> <i> <CallPLusIcon /> </i> <span>Home</span> </NavLink>
              </li>}

              {permissionList.includes(DASHBOARD_PERMISSION) && <li className={pathname.startsWith("/dashboard") ? "active" : ""}>
                <NavLink to={`/dashboard/${userDetails.user.uuid}`}> <i> <DashboardIcon /> </i>  <span>My Dashboard</span> </NavLink>
              </li>}

              {permissionList.includes(TEAM_DASHBOARD_PERMISSION) &&
                <li className={pathname.startsWith("/team/dashboard") ? "active" : ""} >
                  <NavLink to={`/team/dashboard/${userDetails?.user?.group?.uuid}`}>
                    <i> <TeamDashboardIcon /> </i>
                    <span>Team Dashboard</span>
                  </NavLink>
                </li>}

              {permissionList.includes(ACTIVITY_PERMISSION) &&
                <li className={pathname.startsWith("/my/activity") ||
                  pathname.startsWith("/create/alignedworkflowsession") ||
                  pathname.startsWith("/create/reportworkflow") ? "active" : ""} >
                  <NavLink to={`/my/activity/${userDetails?.user?.uuid}`}>
                    <i> <AssignedWorkflowIcon /> </i>
                    <span>My Activity</span>
                  </NavLink>
                </li>}

              {permissionList.includes(WORKFLOW_BUILDER_PERMISSION) && <li className={pathname.startsWith("/workflow/author") || pathname.startsWith("/create/publishedtask") || pathname.startsWith("/create/workflowversionlist") || pathname.startsWith("/create/task") ? "active" : ""} >
                <NavLink to="/workflow/author"> <i> <WorkflowIcon /> </i> <span> Workflow Builder</span> </NavLink>
              </li>}

              <li className={pathname === "/create/callstaistics" ? "active" : ""}>
                <NavLink to="/create/callstaistics" onClick={() => sessionStorage.removeItem("call_staistics")}>
                  <i> <CallIcon /> </i>
                  <span style={{ marginLeft: "0.3rem" }}>Call Logs</span>
                </NavLink>
              </li>

              {permissionList.includes(QUESTION_BANK_PERMISSION) && <li
                className={`dropdownmenusidebar ${this.state.openSubMenu === "library" ||
                  pathname.includes("/create/mcqbanklist") ||
                  pathname.includes("/create/rangebanklist") ||
                  pathname.includes("/create/parentchildbanklist") ||
                  pathname.includes("/create/mcqbankcreate") ||
                  pathname.includes("/create/mcqbankedit") ||
                  pathname.includes("/create/rangebankcreate") ||
                  pathname.includes("/create/rangebankcreate") ||
                  pathname.includes("/create/parentchildbankcreate")
                  ? "active"
                  : ""
                  }`}
              >
                <NavLink to="#" onClick={() => this.handleSubMenuToggle("library")} className="d-flex justify-content-between align-items-center">
                  <span className="d-flex align-items-center">
                    <i> <LibraryIcon /> </i>
                    <span className="ml-2">Library</span>
                  </span>
                  <i className={`icon-arrow-right ${this.state.openSubMenu === "library" ? "rotate-90" : ""}`}></i>
                </NavLink>

                {this.state.openSubMenu === "library" && (
                  <ul className="xp-vertical-submenu pl-0">
                    <li>
                      <NavLink to="/create/mcqbanklist">MCQ</NavLink>
                    </li>
                    <li>
                      <NavLink to="/create/rangebanklist">Range</NavLink>
                    </li>
                    <li>
                      <NavLink to="/create/parentchildbanklist">Question Hierarchy</NavLink>
                    </li>
                  </ul>
                )}
              </li>}

              <li className={pathname.startsWith("/files") ? "active" : ""}>
                <NavLink to="/files">
                  <i> <FilesIcon /> </i>
                  <span>Files</span>
                </NavLink>
              </li>

              <li className={pathname.startsWith("/create/faq") ? "active" : ""}>
                <NavLink to="/create/faq">
                  <i> <FaqIcon /> </i>
                  <span>FAQ</span>
                </NavLink>
              </li>

            </ul>
          </div>
        </div>
      </div>
    );
  }
}
const mapStateToProps = (state) => ({
  userDetails: state.userData.userDetails,
});

export default withRouter(connect(mapStateToProps)(Sidebar));
